import { FC } from 'react';
import { Avatar, AvatarProps } from 'antd';
import { getUserInitials } from 'src/utils/stringHelpers';
import { generateColor } from 'src/utils/randomColorGenerator';

const mapSize = {
  xs: '18px',
  xl: '38px',
};

const mapFontSize = {
  xs: '11px',
  xl: '26px',
};

const isCustomSize = (size: UserAvatarProps['size']): size is 'xs' | 'xl' => {
  return size !== undefined && size in mapSize;
};

export interface UserAvatarProps extends Omit<AvatarProps, 'size'> {
  user?: Record<string, any>;
  shape?: 'square' | 'circle'
  size?: 'large' | 'small' | 'xs' | 'xl';
}

const UserAvatar: FC<UserAvatarProps> = ({
  user,
  size,
  shape = 'square',
  style = {},
  ...props
}) => {
  const initials = getUserInitials(user as any);

  return (
    <Avatar
      shape={shape}
      size={!isCustomSize(size) ? size : undefined}
      style={{
        width: isCustomSize(size) ? mapSize[size] : undefined,
        height: isCustomSize(size) ? mapSize[size] : undefined,
        lineHeight: isCustomSize(size) ? mapSize[size] : undefined,
        fontSize: isCustomSize(size) ? mapFontSize[size] : undefined,
        background: generateColor(user?.email),
        ...style,
      }}
      {...props}
    >
      {initials}
    </Avatar>
  );
};

export default UserAvatar;
